import React from 'react';
import { Modal, Spin } from 'antd';

const SubscriptionSection = ({
    subscriptionInfo,
    subscriptionStatusLabel,
    subscriptionEndDate,
    currentPlan,
    userData,
    isSubscriptionModalOpen,
    setIsSubscriptionModalOpen,
    isCancelling,
    handleCancelSubscription,
    subscriptionStatusLoading,
    resumeSubscriptionLoading,
    cancelSubscriptionLoading,
    handleResumeSubscription,
    onOpenChangeCardModal,
}) => {
    return (
        <>
            {subscriptionInfo?.hasSubscription && (
                <>
                    <div className="border-b-1-e1e6ef my-30" />

                    <h6 className="m-0 pb-12 f-22 fw-normal poly c-0f151d">
                        Subscription settings
                    </h6>
                    <div className="subscription-settings-row">
                        <span className="f-15 poppins c-667085">
                            Subscription Status
                        </span>

                        <span
                            className={`subscription-status-pill ${
                                subscriptionInfo?.status === 'cancel_scheduled'
                                    ? 'subscription-status-pill--warning'
                                    : subscriptionInfo?.status === 'downgrade_scheduled'
                                    ? 'subscription-status-pill--info'
                                    : subscriptionInfo?.status === 'no_subscription'
                                    ? 'subscription-status-pill--neutral'
                                    : 'subscription-status-pill--success'
                            }`}
                        >
                            <span className="subscription-status-pill__dot" />
                            <span className="subscription-status-pill__text">
                                {subscriptionStatusLabel}
                            </span>
                        </span>
                    </div>
                    <div className="subscription-settings-row mt-2">
                        <span className="f-15 poppins c-667085 fw-400 w-60">
                            Subscription expiry date
                        </span>
                        <span>
                            <span className="poppins fs-14 c-333333 w-40 ms-1">
                                {subscriptionEndDate}
                            </span>
                        </span>
                    </div>
                    <div className="subscription-settings-row mt-2">
                        <span className="f-15 poppins c-667085 fw-400 w-60">
                            Current plan
                        </span>
                        <span className="poppins fs-14 c-333333 w-40 ms-1">
                            {currentPlan?.name ||
                                subscriptionInfo?.subscription?.plan_id ||
                                'N/A'}
                        </span>
                    </div>
                    {!subscriptionInfo?.cancelAtPeriodEnd &&
                    subscriptionInfo?.status !== 'cancel_scheduled' &&
                    subscriptionInfo?.status !== 'downgrade_scheduled' ? (
                        <div className="subscription-action-row mt-3">
                            <a
                                className="subscription-action-link"
                                onClick={() => setIsSubscriptionModalOpen(true)}
                            >
                                Cancel subscription
                            </a>
                            <span></span>
                        </div>
                    ) : (
                        <div className="subscription-action-row mt-3">
                            <button
                                type="button"
                                className="btn subscription-action-button border-1-e1e6ef"
                                onClick={
                                    subscriptionInfo?.status === 'cancel_scheduled'
                                        ? handleResumeSubscription
                                        : () => setIsSubscriptionModalOpen(true)
                                }
                                disabled={
                                    isCancelling ||
                                    subscriptionStatusLoading ||
                                    resumeSubscriptionLoading ||
                                    cancelSubscriptionLoading
                                }
                            >
                                {subscriptionInfo?.status === 'cancel_scheduled'
                                    ? resumeSubscriptionLoading
                                        ? 'Resuming...'
                                        : 'Resume subscription'
                                    : 'Cancel Subscription'}
                            </button>
                        </div>
                    )}
                </>
            )}

            {userData?.subscriptionCard && (
                <>
                    <div className="border-b-1-e1e6ef my-30" />
                    <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 pb-24">
                        <div>
                            <h6 className="m-0 pb-12 f-22 fw-normal poly c-0f151d">
                                Linked Card
                            </h6>
                            <span className="d-block f-14 fw-normal text-gray poppins">
                                Manage the credit or debit card linked to your business account for subscriptions.
                            </span>
                        </div>
                        <button
                            type="button"
                            className="btn btn-outline-success fw-semibold poppins px-4 py-2 ms-auto"
                            style={{
                                borderRadius: "8px",
                                fontSize: "13px",
                                border: "1px solid #10b981",
                                color: "#10b981",
                                background: "transparent",
                            }}
                            onClick={onOpenChangeCardModal}
                        >
                            Change Card
                        </button>
                    </div>

                    {/* Center Card */}
                    <div className="d-flex justify-content-center">
                        <div className="payment-card-premium">
                            <div className="d-flex justify-content-between align-items-center">
                                <span className="payment-card-brand">
                                    {userData.subscriptionCard.brand}
                                </span>
                            </div>

                            <div className="payment-card-number mt-3">
                                •••• •••• •••• {userData.subscriptionCard.last4}
                            </div>

                            <div className="d-flex justify-content-between align-items-end mt-3">
                                <div className="d-flex flex-column">
                                    <span className="payment-card-label">Expires</span>
                                    <span className="payment-card-value">
                                        {userData.subscriptionCard.exp_month}/
                                        {String(userData.subscriptionCard.exp_year).slice(-2)}
                                    </span>
                                </div>

                                <div className="payment-card-chip"></div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            <Modal
                open={isSubscriptionModalOpen}
                onCancel={() => setIsSubscriptionModalOpen(false)}
                footer={null}
            >
                <h4>Confirmation required</h4>
                <p className="mb-5">
                    {`Are you sure you want to cancel your subscription`}
                </p>
                <div className="d-flex gap-3 justify-content-end">
                    <button
                        disabled={isCancelling}
                        className="btn btn-outline"
                        onClick={() => setIsSubscriptionModalOpen(false)}
                    >
                        Cancel
                    </button>
                    <button
                        disabled={isCancelling}
                        className={`btn btn-danger `}
                        onClick={handleCancelSubscription}
                    >
                        {isCancelling ? <Spin /> : 'Yes, Proceed'}
                    </button>
                </div>
            </Modal>
        </>
    );
};

export default SubscriptionSection;
